import { render, staticRenderFns } from "./_Loader.vue?vue&type=template&id=241bc922&scoped=true&"
import script from "./_Loader.vue?vue&type=script&lang=js&"
export * from "./_Loader.vue?vue&type=script&lang=js&"
import style0 from "./_Loader.vue?vue&type=style&index=0&id=241bc922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241bc922",
  null
  
)

export default component.exports